import React, { useEffect, useRef, useState } from "react";
import api from "../api/api"
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth } from "../context/AuthContext";
import PropTypes from 'prop-types';
import Select from 'react-select';
import { useTranslation } from "react-i18next";

const CreateBooking = (prop) => {


    const { t } = useTranslation();
    const {user} = useAuth();
    const modalRef = useRef(null);
    const [agencies, setAgencies] = useState([]);
    const [biodatas, setBiodatas] = useState([]);
    const [employers, setEmployers] = useState([]);
    const [isSupplierBiodata, setIsSupplierBiodata] = useState(false);
    

    const schema = yup.object({
        company: yup.string(),
        other_company: yup.string(),
        biodata: yup.string().required("Biodata is required"),
        employer_id: user.type === "agency" ? yup.string().required("Employer is required") : yup.string(),
        notes: yup.string().max(500, "Notes cannot exceed 500 characters"),
    }).test("company-or-other-company", null, function (value) {
        const { company, other_company } = value;
        if (!company && !other_company) {
            return this.createError({ path: "company", message: "Either Company or Other Company must be filled" });
        }
        return true;
    })


    const {
      reset,
      handleSubmit,
      register,
      setError,
      clearErrors,
      control,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(schema),
      //defaultValues: inputValues,
    });


    const fetchData = async () => {
        try {
            let get_biodata_url;
            let get_compny_url;
            let get_employer_url;
            if (user.type === "supplier") {
                get_biodata_url = "/get-supplier-biodata";
                get_compny_url = "/get-agency-list";
            }
            else if (user.type === "agency") {
                get_biodata_url = "/get-agency-biodata";
                get_compny_url = "/get-vendor-list";

                get_employer_url = "/get-employer";
                const responseEmployer = await api.get(get_employer_url);
                setEmployers(responseEmployer.data.employers || []);
            }

            const response = await api.get(get_compny_url);
            setAgencies(response.data.agencies || response.data.suppliers || []);

            const responseBiodata = await api.get(get_biodata_url, {
                params: {
                    "status": "Published",
                    "agency_id": user.company.id, // Assuming user.id is the agency ID
                    "vendor_id": user.company.id, // Assuming user.id is the supplier ID
                },
            });
            setBiodatas(responseBiodata.data || []);
           
        } catch (error) {
            console.error("Error fetching agencies or biodata:", error);
        }
    };

    const fetchVendorBiodata = async (vendorId) => {
        try {
            const response = await api.get(`/get-shared-biodata/`, {
                params: {
                    "vendor_id": vendorId,
                    "status": "Published",
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching vendor biodata:", error);
            return null;
        }
    };

    const handleVendorChange = async (option) => {
        const selectedVendorId = option;
        if (selectedVendorId != undefined && selectedVendorId != null && selectedVendorId != "") {

            let biodata = await fetchVendorBiodata(selectedVendorId);
            if(Array.isArray(biodata)){
                setBiodatas(biodata)
            }

            // Clear the other_company field if a vendor is selected
            clearErrors("other_company");
            document.querySelector('input[name="other_company"]').disabled = true;

            // set isSupplierBiodata to true
            setIsSupplierBiodata(true);
            
        } else {
            let biodata = await api.get("/get-agency-biodata", {
                params: {
                    "status": "Published",
                    "agency_id": user.company.id, // Assuming user.id is the agency ID
                },
            });
            setBiodatas(biodata.data || []);

            // disable the other_company field
            document.querySelector('input[name="other_company"]').disabled = false;
            setError("other_company", {
                type: "manual",
                message: "Please enter the vendor name if not selected from the list.",
            });

            // set isSupplierBiodata to false
            setIsSupplierBiodata(false);
        }
    }

    const agencyOptions = agencies.map((agency) => ({
        value: agency.id,
        label: agency.name
    }));


    useEffect(() => {
        if (!prop.isOpen) return;
        fetchData();
    }, [prop.isOpen]);

     const [loadingSendInv,setloadingSendInv] = useState(false)
     const [successinvite,setsuccessinvite] = useState(null)
    const { onRefresh } = prop;

     
     const onSubmit = async(data) => {
        clearErrors();
        setsuccessinvite(null)
        let typeurl ="/booking/"

        if (loadingSendInv) return;
        setloadingSendInv(true);
        
        try {
            data = {
                ...data,
                is_supplier_biodata: isSupplierBiodata,
            }
            const response = await api.post(typeurl, data ); 

            reset();
            setsuccessinvite(response.data['result'])

            if (onRefresh) onRefresh();

            document.querySelector('#create-booking .btn-close')?.click();
        } catch (error) {
       
           let  errorMessage = ""
            // Extract response code if available
            const responseCode = error.response ? error.response.status : "Unknown";
            console.log("Response Code:", responseCode);
            if (error?.response?.data) {
                
                 Object.entries(error.response.data).forEach(([key, values]) => {
                   //if (key !== "token" && key !== "invite-agency-vendo") {
                     console.log(key, values);
                     errorMessage += `${values}\n`;
                   //}
                 });
               }
             
               // If no specific error was found, provide a default message
               if (!errorMessage) {
                
                 errorMessage = "An unknown error occurred.";
               }
               
               // Set the error message in React Hook Form
               setError("root", { type: "server", message: errorMessage });
   
        } finally {
            setloadingSendInv(false);
        }
    }
    
    useEffect(()=>{
        clearErrors();
    },[])

    return (
        <div className="modal custom-modal modal-lg fade" id="create-booking" role="dialog" ref={modalRef}>
            <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                    <div className="modal-header border-0 pb-0">
                        <div className="form-header modal-header-title text-start mb-0">
                            <h4 className="mb-0">{t('Create')}</h4>
                        </div>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form  onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-body">
                                        <div className="form-groups-item">
                                            <div className="row">
                                                <div className="col-md-12">

                                                    <div className="input-block">
                                                        <label>{t(user.type == 'agency' ? 'Vendor Name' : 'Agency Name')}</label>
                                                        <Controller
                                                        name="company"
                                                        control={control}
                                                        rules={{ required: "Company is required" }}
                                                        render={({ field }) => (
                                                            <Select
                                                            {...field}
                                                            options={agencyOptions}
                                                            placeholder={t("Select Option")}
                                                            isClearable
                                                            value={agencyOptions.find((option) => option.value === field.value) || null}
                                                            onChange={(selectedOption) => {
                                                                field.onChange(selectedOption ? selectedOption.value : "");

                                                                // Custom action after selecting agency
                                                                if (user.type === 'agency') {
                                                                handleVendorChange(selectedOption?.value);
                                                                }
                                                            }}
                                                            />
                                                        )}
                                                        />


                                                        <small className="text-muted">
                                                            If the {user.type == 'agency' ? 'vendor' : 'agency'} is not in the list, you can enter it manually below.
                                                        </small> <br />
                                                        <small className="text-danger">{t(errors?.company?.message)}</small>
                                                    </div>

                                                    <div className="input-block mt-2">
                                                        <label>{t(user.type == 'agency' ? 'Other Vendor (optional)' : 'Other Agency (optional)')}</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={t(`Enter ${user.type == 'agency' ? 'vendor' : 'agency'} name manually`)}
                                                            {...register("other_company")}
                                                        />
                                                        <small className="text-danger">{t(errors?.other_company?.message)}</small>
                                                    </div>

                                                    <div className="input-block mb-3">
                                                        <label>{t('Biodata')}</label>
                                                        <Controller
                                                            name="biodata"
                                                            control={control}
                                                            rules={{ required: "Biodata is required" }}
                                                            render={({ field }) => (
                                                                <Select
                                                                {...field}
                                                                options={biodatas.map((biodata) => ({
                                                                    value: biodata.id,
                                                                    label: `${biodata.code} - ${biodata.name}`
                                                                }))}
                                                                placeholder={t("Select Biodata")}
                                                                isClearable
                                                                value={biodatas
                                                                    .map((biodata) => ({
                                                                    value: biodata.id,
                                                                    label: `${biodata.code} - ${biodata.name}`
                                                                    }))
                                                                    .find((option) => option.value === field.value) || null}
                                                                onChange={(selectedOption) => {
                                                                    field.onChange(selectedOption ? selectedOption.value : "");
                                                                }}
                                                                />
                                                            )}
                                                            />

                                                        <small className="text-danger">{t(errors?.biodata?.message)}</small>
                                                    </div>
                                                    {
                                                        user.type === "agency" && (
                                                            <div className="input-block mt-2">
                                                                <label>{t('Employer')}</label>
                                                               <Controller 
                                                                name="employer_id"
                                                                control={control}
                                                                render={({ field }) => (
                                                                    <Select
                                                                    options={employers.map((employer) => ({
                                                                        value: employer.id,
                                                                        label: employer.name
                                                                    }))}
                                                                    placeholder={t("Select Employer")}
                                                                    isClearable
                                                                    value={employers
                                                                        .map((employer) => ({
                                                                        value: employer.id,
                                                                        label: employer.name
                                                                        }))
                                                                        .find(option => option.value === field.value)}
                                                                    onChange={(selectedOption) => {
                                                                        field.onChange(selectedOption ? selectedOption.value : "");
                                                                    }}
                                                                    />
                                                                )}
                                                                />

                                                                <small className="text-danger">{t(errors?.employer_id?.message)}</small>
                                                            </div>
                                                        )
                                                    }
                                                    <div className="input-block mb-3">
                                                        <label>{t('Notes')}</label>
                                                        <textarea
                                                            className="form-control"
                                                            rows="4"
                                                            placeholder={t('Enter Notes')}
                                                            {...register("notes")}
                                                        ></textarea>
                                                        <small className="text-danger">{errors?.notes?.message}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                        {/* <small  style={{color:"green"}}> {successinvite && <p>Your invitation was successfully delivered to <b>{successinvite}</b></p>}</small> */}
                        <small  style={{color:"red"}}> {errors.root && <p>{errors.root.message}</p>}</small>
                        <div className="d-flex justify-content-end w-100 mt-2">
                            <button type="button" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">{t('Cancel')}</button>
                            <button type="submit"  className="btn btn-primary ">{t('Submit')}
                            {loadingSendInv && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i> }
                            
                            </button>
                        </div>    
                        </div>
                    </form>
                </div>
            </div>
        </div>
    ); 
};
CreateBooking.propTypes = {
    refreshData: PropTypes.func.isRequired,
  };
export default CreateBooking;
